module.exports = __webpack_public_path__ + "img/u72.c13c09ad.svg";